import { Divider } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { breakPoints, customBreakPoint } from '~/styles/break-points';

import { transitionDuration, transitionTiming } from '~/styles/tokens';

export const StyledDivider = styled(Divider)`
	margin: 28px 0;
	${breakPoints({
		'1024': `display: none`,
	})};
`;

export const DialogWrapper = styled.div<{ $itemCount: number }>`
	display: none;
	grid-template-rows: repeat(4, auto);
	grid-template-columns: repeat(${({ $itemCount }) => $itemCount}, 1fr);
	${customBreakPoint(1024, `display: grid; `)}
	max-width: 1440px;

	.header {
		background-color: white;
		z-index: 1;
		position: sticky;
		top: -4rem;
		display: grid;
		grid-template-columns: repeat(${({ $itemCount }) => $itemCount}, 1fr);
		grid-column: 1 / -1;
		border-bottom: 1px solid #d9d9d9;
	}

	.header__title {
		padding: 0.2rem 1.5rem 1rem 1.5rem;
		border-right: 1px solid #d9d9d9;
	}

	.header__title:last-of-type,
	.header__content:last-of-type,
	.content__teaser-text:last-of-type,
	.content:last-of-type {
		border-right: none;
	}

	.header__content,
	.content,
	.content__teaser-text {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		padding: 0 1.5rem;
		padding-bottom: 1rem;
		border: 0px solid #d9d9d9;
		border-right-width: 1px;
	}

	.header__content button {
		margin-top: auto;
	}

	.content__teaser-text {
		padding-bottom: 1.5rem;
	}

	img {
		padding-top: 1rem;
	}
`;

export const MobileContainer = styled.div`
	display: block;
	${customBreakPoint(1024, 'display: none;')}
	overflow-x: clip;

	.header {
		background-color: white;
		position: sticky;
		top: -3.5rem;
		display: flex;
		z-index: 1;
		flex-direction: column;
		gap: 1rem;
		padding-top: 0.2rem;
		padding-bottom: 1rem;
	}
	.teaserText {
		margin-top: 1.5rem;
	}

	.features-title {
		margin-bottom: 12px;
	}
`;

export const StyledSlider = styled.div<{ gap: number }>`
	width: fit-content;

	.cards-wrapper {
		display: flex;
		transition: transform;
		transition-timing-function: ${transitionTiming};
		transition-duration: ${transitionDuration}ms;
		gap: ${(props) => props.gap + 'px'};
	}
`;

export const StyledCard = styled.div<{ isShown: boolean }>`
	padding: 1rem;
	width: 200px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 1rem;
	min-height: 104px;
	box-shadow:
		0 1px 2px rgba(0, 0, 0, 0.1),
		0 2px 6px rgba(0, 0, 0, 0.2);
	border: ${(props) => (props.isShown ? 'black 0.5px solid' : '')};
`;
